<script setup>
const props = defineProps({ error: Object })

const is404 = computed(() => props.error?.statusCode === 404)
</script>

<template>
  <v-app>
    <v-container class="d-flex align-center justify-center" style="min-height: 100vh;">
      <div class="text-center">
        <h1 class="text-h1 font-weight-bold text-primary mb-4">
          {{ error?.statusCode || 500 }}
        </h1>
        <p class="text-h5 font-weight-light mb-2">
          {{ is404 ? 'Page not found' : 'Something went wrong' }}
        </p>
        <p class="text-body-1 text-medium-emphasis mb-8">
          {{ is404 ? "The page you're looking for doesn't exist or has been moved." : error?.message }}
        </p>
        <v-btn color="primary" size="large" to="/" @click="clearError({ redirect: '/' })">
          <v-icon class="mr-2">
            mdi-home
          </v-icon>
          Back to Home
        </v-btn>
      </div>
    </v-container>
  </v-app>
</template>
